var moduleMap = {
	"./bootstrap": () => {
		return Promise.all([__webpack_require__.e(8677), __webpack_require__.e(844), __webpack_require__.e(8301), __webpack_require__.e(1178), __webpack_require__.e(2036), __webpack_require__.e(2412), __webpack_require__.e(5354), __webpack_require__.e(6992), __webpack_require__.e(5269), __webpack_require__.e(6471), __webpack_require__.e(3659), __webpack_require__.e(794), __webpack_require__.e(1744), __webpack_require__.e(1795), __webpack_require__.e(909), __webpack_require__.e(4024), __webpack_require__.e(3464), __webpack_require__.e(5342), __webpack_require__.e(5493), __webpack_require__.e(6207)]).then(() => (() => ((__webpack_require__(90634)))));
	},
	"./monitor": () => {
		return Promise.all([__webpack_require__.e(8301), __webpack_require__.e(1178), __webpack_require__.e(2036), __webpack_require__.e(2412), __webpack_require__.e(5354), __webpack_require__.e(6992), __webpack_require__.e(6471), __webpack_require__.e(794), __webpack_require__.e(1795), __webpack_require__.e(909), __webpack_require__.e(4024), __webpack_require__.e(5342), __webpack_require__.e(2599)]).then(() => (() => ((__webpack_require__(52599)))));
	},
	"./monitor/MonitorApp": () => {
		return Promise.all([__webpack_require__.e(8677), __webpack_require__.e(844), __webpack_require__.e(8301), __webpack_require__.e(1178), __webpack_require__.e(2036), __webpack_require__.e(2412), __webpack_require__.e(5354), __webpack_require__.e(6992), __webpack_require__.e(5269), __webpack_require__.e(6471), __webpack_require__.e(794), __webpack_require__.e(1744), __webpack_require__.e(1795), __webpack_require__.e(909), __webpack_require__.e(3464), __webpack_require__.e(5342), __webpack_require__.e(5493), __webpack_require__.e(6916)]).then(() => (() => ((__webpack_require__(32136)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});